<template>
  <div class="share">
    <template v-for="(item, key) in shareList">
      <button
        :key="key"
        type="button"
        :title="item.title"
        @click="item.shareFunction"
      >
        <component :is="item.components" />
      </button>
    </template>
  </div>
</template>

<script>
import isKorean from '@/mixins/isKorean'

export default {
  components: {
    iconKakaotalk: () => import('@/static/svg/kakaotalk.svg'),
    iconFacebook: () => import('@/static/svg/facebook.svg'),
    iconTwitter: () => import('@/static/svg/twitter.svg'),
    iconMail: () => import('@/static/svg/mail.svg'),
    iconLink: () => import('@/static/svg/link.svg'),
  },
  mixins: [isKorean],
  props: {
    list: {
      type: Array,
      default: () => ['kakaotalk', 'facebook', 'twitter', 'mail', 'link']
    },
    type: {
      type: String,
      default: 'type',
    },
    title: {
      type: String,
      default: 'title',
    },
    description: {
      type: String,
      default: '',
    },
    seq: {
      type: Number,
      default: 0,
    },
    shareImage: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      share: {
        kakaotalk: {
          title: '카카오톡',
          components: 'iconKakaotalk',
          shareFunction: this.kakaotalkShare
        },
        facebook: {
          title: '페이스북',
          components: 'iconFacebook',
          shareFunction: this.facebookShare
        },
        twitter: {
          title: '트위터',
          components: 'iconTwitter',
          shareFunction: this.twitterShare
        },
        mail: {
          title: '메일',
          components: 'iconMail',
          shareFunction: this.mailShare
        },
        link: {
          title: '링크 복사',
          components: 'iconLink',
          shareFunction: this.link
        }
      }
    }
  },
  computed: {
    imagePath (vm) {
      return vm.isKorean ? `${process.env.VUE_APP_CDN_PATH}/static/image/share_kor.jpg` : `${process.env.VUE_APP_CDN_PATH}/static/image/share_eng.jpg`
    },
    shareList (val) {
      return val.list.map(item => {
        return val.share[item]
      })
    },
    url (vm) {
      const language = vm.isKorean ? 'KR' : 'EN'

      let path = ''

      // if (vm.$route.name === 'Fonts') {
      //   path = `${process.env.VUE_APP_DOMAIN}/share/font?language=${language}`
      // } else {
      //   path = `${process.env.VUE_APP_DOMAIN}/share/content/${vm.seq}?contentType=${vm.type}&language=${language}`
      // }
      switch (vm.$route.name) {
        case 'Fonts':
          path = `${process.env.VUE_APP_DOMAIN}/share/font?language=${language}`
          break
        case 'Music':
          path = `${process.env.VUE_APP_DOMAIN}/share/music?language=${language}`
          break
        default:
          path = `${process.env.VUE_APP_DOMAIN}/share/content/${vm.seq}?contentType=${vm.type}&language=${language}`
          break
      }

      return path
    }
  },
  methods: {
    kakaotalkShare (e) {
      const shareImagePath = this.shareImage ? this.shareImage : this.imagePath

      const sendOptions = {
        objectType: 'feed', // 메시지 형식 : 피드 타입
        content: {
          title: this.title,
          imageUrl: shareImagePath, // 메인으로 보여질 이미지 주소
          link: {
            webUrl: this.url,
            mobileWebUrl: this.url,
          },
        },
        buttons: [
          {
            title: '자세히 보기', // 버튼 이름
            link: {
              webUrl: this.url,
              mobileWebUrl: this.url,
            },
          },
        ],
        installTalk: true
      }

      if (this.description.length > 0) {
        sendOptions.content.description = this.description
      }

      window.Kakao.Link.sendDefault(sendOptions)

      this.$emit('click:share', e, 'kakaotalk')
    },
    facebookShare (e) {
      const encoderUrl = encodeURIComponent(this.url)
      const facebook = 'https://www.facebook.com/sharer/sharer.php?u='
      const link = facebook + encoderUrl
      window.open(link)

      this.$emit('click:share', e, 'facebook')
    },
    twitterShare (e) {
      const encoderTitle = encodeURIComponent(this.title)// 공유될 url 타이틀
      const encoderUrl = encodeURIComponent(this.url)// 전달할 URL
      const link = `https://twitter.com/intent/tweet?url=${encoderUrl}&text=${encoderTitle}`
      window.open(link, '우아한', 'width=400, height=400')

      this.$emit('click:share', e, 'twitter')
    },
    mailShare (e) {
      const encoderUrl = encodeURIComponent(this.url)
      window.open(`mailto:?subject=${this.title}&body=${encoderUrl}`)

      this.$emit('click:share', e, 'mail')
    },
    link (e) {
      const input = document.createElement('input')
      document.body.appendChild(input)
      input.value = this.url
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      // alert('URL 복사가 완료되었습니다.')
      this.$root.$emit('toast:show', {
        text: this.$t('urlCopied')
      })

      this.$emit('click:share', e, 'link')
    }
  }
}
</script>
